export default __webpack_public_path__ + "static/media/ViewTabEnable.5de37cb6.svg";